<div class="tab-style">
  @if (items.length) {
    <div class="tab-container">
      @if (oversized) {
        <div class="prev action flex items-center" (click)="paging(true)" [class.inactive]="nextLinkInactive">
          <i class="icon-left-open"></i>
        </div>
      }
      <div class="time-tabs flex flex-1" #tabsWrapper pan (panstart)="panStart()" (pan)="pan($event)" (panend)="panEnd($event)">
        <div class="tabs" #tabsContainer>
          @for (item of items; track item.value) {
            <div #tabs (click)="selectItem(item.value)" class="tab" [class.active]="selectedItem === item.value">
              <span>{{ item.label }}</span>
            </div>
          }
        </div>
      </div>
      @if (oversized) {
        <div class="next action flex items-center" (click)="paging(false)" [class.inactive]="prevLinkInactive">
          <i class="icon-right-open"></i>
        </div>
      }
    </div>
  }
</div>
